import React from 'react';

import CSSModules from 'react-css-modules';

import Text from '../../../../TextComponents/Text';

import styles from '../styles.module.scss';

type QuestionCountHeaderProps = {
  numberOfQuestions: number;
  questionNumberText?: string;
};

const QuestionCountHeader = ({
  numberOfQuestions,
  questionNumberText,
}: QuestionCountHeaderProps): JSX.Element | null => {
  if (numberOfQuestions < 2) {
    return null;
  }

  return (
    <div styleName='question-number'>
      <Text size='m' colour='grey700'>
        {questionNumberText}
      </Text>
    </div>
  );
};

export default CSSModules(QuestionCountHeader, styles);
